import axios from "@/libs/api.request.js";
import { WX_URL } from "@/config";

// 获取OPEN ID/用户接口
export const getUser = (params) =>
  axios.request({ url: "/task/user", params, method: "get" });

// 绑定用户接口，微信公众号使用
export const bind = (data) => axios.request({ url: "/task/bind", data });

// 解绑用户接口
export const remove = (data) => axios.request({ url: "/remove", data });

// 获取微信签名接口
export const wechatSign = (data) =>
  axios.request({ baseURL: WX_URL, url: "/api/get_wechat_sign", data });
